<template>
  <div :class="currentStepClass" class="active">
    <keep-alive>
      <component
        :is="currentStepComponent"
        :step="step"
        :user="user"
        :useIdCard="useIdCard"
        :companyName="companyName"
        :step-navigation="stepNavigation"
        @show-buttons="showButtons"
        @current-step3-changed="currentStep3Changed"
        @validated="stepValidated" />
    </keep-alive>
    <div class="btn-box step" v-if="isShowButtons">
      <div class="col">
        <button
          type="button"
          class="btn btn-line-dark btn-lg icon icon-arrow_prev left"
          :disabled="step === 1"
          @click="onPreviousStep">
          {{ $t('preRegistration.common.previousStep') }}
        </button>
      </div>
      <div class="col ml-auto">
        <button
          type="button"
          class="btn btn-line-dark btn-lg icon icon-arrow_next"
          @click="onNextStep"
          :disabled="!validated">
          {{ $t('preRegistration.common.nextStep') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import innerSteps from '@/mixins/inner_steps';
  import {STEP3_INNER} from '@/js/common/constants';

  export default {
    name: 'StepWrapper',
    mixins: [innerSteps],
    components: {
      Step1: () => import('@/components/demo/Step1'),
      Step2: () => import('@/components/demo/Step2'),
      Step3: () => import('@/components/demo/Step3'),
      Step4: () => import('@/components/demo/Step4'),
      StepBox: () => import('@/components/demo/StepBox'),
    },
    data() {
      return {
        validated: false,
        isShowButtons: false,
        currentStep3: STEP3_INNER['MY_INFO'],
        stepNavigation: {
          from: -1,
          to: -1,
        },
      };
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
      step: {
        type: Number,
      },
      useIdCard: Boolean,
      companyName: String,
    },
    methods: {
      onPreviousStep() {
        const step = this.step;
        this.stepNavigation = {
          from: step,
          to: step - 1,
        };
        this.setStep(step - 1);
      },
      onNextStep() {
        const step = this.step;
        this.stepNavigation = {
          from: step,
          to: step + 1,
        };
        this.setStep(step + 1);
      },
      setStep(step) {
        this.$store.commit('steps/setStep', step);
      },
      stepValidated(validated) {
        this.validated = validated;
      },

      currentStep3Changed(innerStep) {
        this.currentStep3 = innerStep;
      },

      // 이전/다음 노출
      showButtons(visible) {
        this.isShowButtons = visible;
      },
    },
    computed: {
      currentStepClass() {
        return 'wrapper-step-'.concat(this.step);
      },
      currentStepComponent() {
        let step = '';
        switch (this.step) {
          case 1:
            step = 'Step1';
            break;
          case 2:
            step = 'Step2';
            break;
          case 3:
            step = 'Step3';
            break;
          case 4:
            step = 'Step4';
            break;
        }
        return step;
      },
      isInnerStep() {
        return (
          this.currentStep3 !== this.STEPS['MY_INFO'] &&
          ![1, 2, 4].includes(this.step)
        );
      },
    },
  };
</script>
